import React, { useEffect, useState } from "react";
import {
  Typography,
  FormLabel,
  TextField,
  Button,
  Box,
  Grid,
} from "@mui/material";
import { useProyecto } from "../../../data/ProyectoContext";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import plusIcon from "../img/PlusIcon.svg";
import PropTypes from 'prop-types';

const ElementosClaveVerificar = ({ promptData, setPromptData }) => {
  const [agregarCriterios, setAgregarCriterios] = useState(false);
  const [nuevoCriterio, setNuevoCriterio] = useState("");
  const [criterioClave, setCriterioClave] = useState(
    promptData.elementos || []
  );
  const { setProyecto } = useProyecto();

  useEffect(() => {
    setCriterioClave(promptData.elementos || []);
  }, [promptData]);

  const handleGuardarCriterio = () => {
    if (nuevoCriterio.trim() !== "") {
      const nuevosCriterios = [...criterioClave, nuevoCriterio];
      setCriterioClave(nuevosCriterios);
      setNuevoCriterio("");
      setAgregarCriterios(false);
      setPromptData((prevData) => ({
        ...prevData,
        elementos: nuevosCriterios,
      }));
    }
  };

  const handleAgregarCriterio = () => {
    setAgregarCriterios(true);
  };

  const handleEliminarCriterio = (index) => {
    const criterioAEliminar = criterioClave[index];
    const nuevosCriterios = criterioClave.filter((_, i) => i !== index);
    setCriterioClave(nuevosCriterios);
    setPromptData((prevData) => ({
      ...prevData,
      elementos: nuevosCriterios,
    }));
    setProyecto((prevProyecto) => ({
      ...prevProyecto,
      elementos: prevProyecto.elementos
        ? prevProyecto.elementos.filter(
            (criterio) => criterio !== criterioAEliminar
          )
        : [],
    }));
  };

  return (
    <Grid item xs={12} sm={12} md={12} lg={12} xl={12} sx={{ mt: 3 }}>
      <Box sx={{ display: "flex", flexDirection: "row" }}>
        <Typography
          sx={{
            fontFamily: "montserrat",
            fontSize: "1.25rem",
            fontWeight: "bold",
            color: "#336B87",
          }}
        >
          Elementos clave a verificar
        </Typography>
      </Box>
      <FormLabel sx={{ fontFamily: "montserrat", fontSize: "0.85rem" }}>
        Escribe los aspectos específicos, comportamientos observables o
        características concretas que deseas verificar en el trabajo o desempeño
        de los estudiantes. Ejemplo: Argumentación
      </FormLabel>
      {agregarCriterios ? (
        <Grid container spacing={2} mt={3} alignItems="center">
          <Grid item xs={12} sm={8}>
            <TextField
              label="Nuevo criterio"
              variant="outlined"
              fullWidth
              value={nuevoCriterio}
              onChange={(e) => setNuevoCriterio(e.target.value)}
              sx={{ fontFamily: "montserrat", mr: 2, mb: 2 }}
              InputProps={{
                sx: {
                  borderRadius: 2,
                  fontFamily: "montserrat",
                  fontSize: "0.75rem",
                  color: "#336B87",
                },
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <Button
              sx={{
                backgroundColor: "#336B87",
                "&:hover": { backgroundColor: "#2B7C83" },
                fontFamily: "montserrat",
                fontWeight: "bold",
              }}
              variant="contained"
              onClick={handleGuardarCriterio}
            >
              Guardar
            </Button>
          </Grid>
        </Grid>
      ) : (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            mt: 3,
            flexWrap: "wrap",
          }}
        >
          {criterioClave.map((criterio, index) => (
            <Box key={index} sx={{ display: "inline-block", m: 1 }}>
              <Button
                variant="outlined"
                onClick={() => handleEliminarCriterio(index)}
                sx={{
                  color: "#336B87",
                  fontFamily: "Montserrat",
                  fontWeight: "medium",
                  fontSize: "1.25rem",
                  borderColor: "rgba(51, 107, 135, 0.3)",
                  borderRadius: 50,
                  backgroundColor: "rgba(51, 107, 135, 0.3)",
                  textTransform: "none",
                  "&:hover": {
                    backgroundColor: "#FFF",
                    borderColor: "#336B87",
                  },
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "montserrat",
                    fontSize: "1.25rem",
                    display: "flex",
                    alignItems: "center",
                    color: "#336B87",
                    textTransform: "none",
                  }}
                >
                  {criterio}
                  <HighlightOffIcon sx={{ ml: 1, color: "#CD5C5C" }} />
                </Typography>
              </Button>
            </Box>
          ))}
          <Button
            variant="outlined"
            sx={{
              fontFamily: "Montserrat",
              fontWeight: "medium",
              fontSize: "1.25rem",
              borderColor: "rgba(51, 107, 135, 0.3)",
              borderStyle: "dashed",
              borderRadius: 50,
              backgroundColor: "#FFF",
              boxShadow: 3,
              "&:hover": {
                backgroundColor: "rgba(51, 107, 135, 0.3)",
                boxShadow: 6,
                borderColor: "rgba(51, 107, 135, 0.3)",
                borderStyle: "dashed",
              },
              color: "#336B87",
              textTransform: "none",
            }}
            onClick={handleAgregarCriterio}
          >
            <img
              src={plusIcon}
              alt="Icono"
              style={{ width: "25px", height: "25px" }}
            />
          </Button>
        </Box>
      )}
    </Grid>
  );
};

ElementosClaveVerificar.propTypes = {
  promptData: PropTypes.func.isRequired,
  setPromptData: PropTypes.func.isRequired,
};

export default ElementosClaveVerificar;
